import React from "react";
import { Product } from "@towersystems/roam-common/lib/generated-types";
import {
  Divider,
  Text,
  FlatListSearchable,
  DEFAULT_PAGE_WIDTH,
} from "@towersystems/roam-common-native";
import { useSearchQueryProvider } from "../../../../utilities/search";
import { Spacings } from "react-native-ui-lib";
import { ProductResourceListItem } from "../ProductResourceListItem/ProductResourceListItem";

export interface ProductResourceListProps {
  items: Product[];
  onEndReached?: () => void;
  onItemPress?: (item: Product) => void;
}

export const ProductResourceList = ({
  items,
  onItemPress,
  onEndReached,
}: ProductResourceListProps) => {
  const { query, setQuery } = useSearchQueryProvider();

  const renderItem = React.useCallback(({ item }: { item: Product }) => {
    return (
      <ProductResourceListItem
        product={item}
        action={() => onItemPress?.(item)}
      />
    );
  }, []);

  return (
    <FlatListSearchable
      contentContainerStyle={{
        maxWidth: DEFAULT_PAGE_WIDTH,
        width: "100%",
        alignSelf: "center",
        paddingHorizontal: Spacings.s5,
        paddingTop: Spacings.s5,
      }}
      placeholder="Search..."
      onChange={(query) => setQuery(query)}
      value={query}
      ItemSeparatorComponent={Divider}
      renderItem={renderItem}
      data={items}
      keyExtractor={(item) => {
        return `${item.id}_${item.updatedAt}`;
      }}
      scrollEnabled={true}
      nestedScrollEnabled
      onEndReachedThreshold={0.3}
      ListEmptyComponent={<Text>No products to show</Text>}
      onEndReached={() => {
        items.length >= 1 && onEndReached && onEndReached();
      }}
    />
  );
};
